<div
  class="page-content-cards container-content"
  fxLayoutAlign="center start"
  *ngIf="!isLoading"
>
  <div class="page-block">
    <h2 class="fs-3 fw-bold">
      {{ 'title.test-registration' | translate }}
    </h2>
    <app-dashboard-exam-card
      *ngFor="let item of items"
      [exam]="item"
    ></app-dashboard-exam-card>
  </div>
  <div class="page-block">
    <h2 class="fs-3 fw-bold" *ngIf="bookings.length">
      {{ 'title.my-bookings' | translate }}
    </h2>
    <app-dashboard-booking-card
      *ngFor="let booking of bookings"
      [booking]="booking"
    ></app-dashboard-booking-card>
  </div>
</div>

<app-loading-indicator-full
  *ngIf="isLoading"
></app-loading-indicator-full>
